import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"
import { type VariantProps, cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const toggleGroupItemVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm",
  {
    variants: {
      variant: {
        default: "rounded-md",
        pill: "rounded-full data-[state=on]:bg-primary data-[state=on]:text-primary-foreground",
      },
      size: {
        default: "h-9 px-3",
        sm: "h-7 px-2.5 text-xs",
        xs: "h-6 px-2 text-[11px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const ToggleGroup = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root>) => (
  <ToggleGroupPrimitive.Root
    className={cn("inline-flex items-center gap-1 rounded-lg bg-muted p-1", className)}
    {...props}
  />
)

interface ToggleGroupItemProps
  extends React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>,
    VariantProps<typeof toggleGroupItemVariants> {}

const ToggleGroupItem = ({ className, variant, size, ...props }: ToggleGroupItemProps) => (
  <ToggleGroupPrimitive.Item
    className={cn(toggleGroupItemVariants({ variant, size, className }))}
    {...props}
  />
)

export { ToggleGroup, ToggleGroupItem, toggleGroupItemVariants }
